// src/pages/About-us.jsx
import React from 'react';
import "./About-us.css";


// Image paths for About Us page
const IMG = {
  hero: "/hero.jpg",
  about1: "/about-1.jpg",
  about2: "/about-2.jpg",
  values: "/values.jpg",
  office: "/office.jpg",
  cta: "/cta.jpg",
  logo1: "/logo1.png",
  logo2: "/logo2.png",
  logo3: "/logo3.png",
};

// Management Team
const TEAM = [
  {
    name: 'Aashish Sharma',
    title: 'Mentor',
    photo: '/aashish.png',
    blurb:
      'Seasoned industry mentor guiding strategy and leadership excellence. Aashish brings cross-domain experience and helps shape decision-making, operating rhythms, and long-term value creation.',
  },
  {
    name: 'Arsh Augutsya',
    title: 'Chief Executive Officer',
    photo: '/arsh.png',
    blurb:
      'Founder & CEO with a product-first mindset. Arsh leads overall vision and execution, aligning technology, design, and business outcomes to build useful, scalable solutions.',
  },

  {
    name: 'Yuvraaj Kumar Singh',
    title: 'Chief Marketing Officer',
    photo: '/Yuvraaj.png',
    blurb:
      'Brand and growth strategist leading go-to-market and user engagement. Yuvraaj blends storytelling with data-driven experimentation to scale awareness and demand.',
  },
  {
    name: 'Deep Chand Singh',
    title: 'Chief Financial Officer',
    photo: '/deep.png',
    blurb:
      'Finance leader focused on governance, capital efficiency, and sustainable growth. Deep oversees financial planning, risk management, and performance reporting.',
  },

  {
    name: 'Vanshaj Singhal',
    title: 'Chief Technology Officer',
    photo: '/vanshaj.png',
    blurb:
      'Engineering leader driving architecture, security, and platform reliability. Vanshaj sets coding standards and fosters a culture of automation, testing, and observability.',
  },

];

export default function AboutUs() {
  return (
    <main className="about">
      {/* HERO */}
      <section className="about-hero" aria-label="About us hero">
        <div
          className="about-hero__media"
          role="img"
          aria-label="Team working in a modern office"
        style={{ backgroundImage: `url(${IMG.hero})` }}
        />
        <div className="about-hero__content container">
          <p className="about-kicker">Who We Are</p>
          <h1 className="about-title">Building useful tech that feels effortless</h1>
          <p className="about-sub">
            We’re a product-first team focused on clarity, speed, and reliability—so your
            users can do more with less effort.
          </p>
        </div>
      </section>

      {/* INTRO / STORY */}
      <section className="section container grid-2" aria-label="Our story">
        <div className="card">
          <h2 className="h2">Our Story</h2>
          <p>
            Augutsya is a techno-commercial consulting partner helping businesses adopt
            modern technology with measurable outcomes. From strategy and architecture to
            delivery and support, we align engineering with business goals.
          </p>
          <p>
            Our approach blends domain expertise with pragmatic execution. We keep solutions
            simple, resilient, and cost-effective—so they scale cleanly and are easy to
            operate.
          </p>
          <ul className="bullets">
            <li>Outcome-driven delivery</li>
            <li>Transparent communication</li>
            <li>Security & cost discipline by default</li>
          </ul>
        </div>

        {/* use image from /public/teamthinking.jpg */}
        <div className="card media">
          <img src="/teamthinking.jpg" alt="Team collaboration" loading="lazy" />
        </div>
      </section>


      {/* WHAT WE DO */}
      <section className="section container grid-2" aria-label="What we do">
        <div className="card media">
          <img src="/piebig.png" alt="Delivering solutions" loading="lazy" />

        </div>
        <div className="card">
          <h2 className="h2">What We Do</h2>
          <p>
            We design and deliver solutions across cloud, apps, data, and automation.
            Whether it’s greenfield build or modernization, we emphasize clean architectures
            and maintainable codebases.
          </p>
          <div className="pill-grid">
            <span className="pill">System Integrator for IT services</span>
            <span className="pill">Data & Analytics</span>
            <span className="pill">Cloud & DevOps</span>
            <span className="pill">Cybersecurity</span>
            <span className="pill">Advisory & PMO</span>
            <span className="pill">Web & App Development</span>
            <span className="pill">Turnkey Infrastructure project executioners</span>
            <span className="pill">Inbound/Outbound Call Centre</span>
            <span className="pill">Personal & Business Accounting</span>
            <span className="pill">Stock Market Advisory</span>
            <span className="pill">Legal Advisory & Corporate Consulting</span>
          </div>
        </div>
      </section>

      {/* VALUES */}
      <section className="section values" aria-label="Our values">
        <div className="container">
          <h2 className="h2 center">Our Values</h2>
          <p className="center muted">Principles that guide every engagement.</p>

          <div className="values-grid">
            <article className="vcard">
              <h3>Clarity</h3>
              <p>Plans are explicit, estimates realistic, and trade-offs documented.</p>
            </article>
            <article className="vcard">
              <h3>Speed</h3>
              <p>Ship iteratively, learn fast, and prioritize what truly moves the needle.</p>
            </article>
            <article className="vcard">
              <h3>Reliability</h3>
              <p>From uptime to support SLAs, we build trust through consistency.</p>
            </article>
            <article className="vcard">
              <h3>Craft</h3>
              <p>Engineering habits: reviews, automation, and observability.</p>
            </article>
          </div>

          <div className="values-media" aria-hidden="true">
            {/* <img src={IMG.values} alt="Our values" loading="lazy" /> */}
          </div>
        </div>
      </section>

      {/* LOGOS (optional) */}
      <section className="section container logos" aria-label="Our ecosystem">
        {/* <img src={IMG.logo1} alt="Partner logo 1" loading="lazy" /> */}
        {/* <img src={IMG.logo2} alt="Partner logo 2" loading="lazy" /> */}
        {/* <img src={IMG.logo3} alt="Partner logo 3" loading="lazy" /> */}
      </section>

      {/* LEADERSHIP */}
      <section className="section container" aria-label="Leadership team">
        <h2 className="h2 center">Leadership</h2>
        <p className="center muted">
          A senior, hands-on team combining strategy, engineering rigor, and market insight.
        </p>

        <div className="team-grid">
          {TEAM.map((m) => (
            <article key={m.name} className="team-card" aria-label={`${m.name}, ${m.title}`}>
              <div className="team-photo">
                <img src={m.photo} alt={`${m.name} — ${m.title}`} loading="lazy" />
              </div>
              <h3 className="team-name">{m.name}</h3>
              <p className="team-title">{m.title}</p>
              <p className="team-blurb">{m.blurb}</p>
            </article>
          ))}
        </div>
      </section>

      {/* OFFICE / TEAM */}
      <section className="section container grid-2" aria-label="Our team & office">
        <div className="card">
          <h2 className="h2">People First</h2>
          <p>
            We hire curious, kind problem-solvers and give them room to do their best work.
            Clients feel the difference in every interaction.
          </p>
          <ul className="bullets">
            <li>Small, senior, full-stack teams</li>
            <li>Security & compliance awareness</li>
            <li>Runbooks, SLIs/SLOs, continuous improvement</li>
          </ul>
        </div>
        <div className="card media">
          <img src="/team.png" alt="Office culture" loading="lazy" />

        </div>
      </section>

      {/* CTA */}
      <section
        className="cta"
        aria-label="Get in touch"
      >
        <div className="cta__overlay" />
        <div className="container cta__content">
          <h2 className="h2">Let’s build something useful</h2>
          <p>Have a project in mind? We can help shape, de-risk, and deliver it.</p>
          <a className='btn' href='/contact-us' aria-label='Go to Contact Us'>
            <span>Contact Us</span>
          </a>
        </div>
      </section>
    </main>
  );
}
